"use client";

import { useRef, useEffect } from "react";

export function DotGrid() {
  const containerRef = useRef<HTMLDivElement>(null);
  const glowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const glow = glowRef.current;
    if (!container || !glow) return;

    const section = container.closest("section");
    const target = section || container;

    const handleMouseMove = (e: MouseEvent) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      glow.style.maskImage = `radial-gradient(circle 200px at ${x}px ${y}px, black 0%, transparent 100%)`;
      glow.style.webkitMaskImage = `radial-gradient(circle 200px at ${x}px ${y}px, black 0%, transparent 100%)`;
    };

    const handleMouseLeave = () => {
      glow.style.maskImage = `radial-gradient(circle 200px at -1000px -1000px, black 0%, transparent 100%)`;
      glow.style.webkitMaskImage = `radial-gradient(circle 200px at -1000px -1000px, black 0%, transparent 100%)`;
    };

    target.addEventListener("mousemove", handleMouseMove as EventListener);
    target.addEventListener("mouseleave", handleMouseLeave as EventListener);

    return () => {
      target.removeEventListener("mousemove", handleMouseMove as EventListener);
      target.removeEventListener("mouseleave", handleMouseLeave as EventListener);
    };
  }, []);

  const gridStyle = {
    backgroundImage:
      "linear-gradient(rgba(52, 211, 153, 0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(52, 211, 153, 0.04) 1px, transparent 1px)",
    backgroundSize: "64px 64px",
  };

  const glowGridStyle = {
    backgroundImage:
      "linear-gradient(rgba(52, 211, 153, 0.25) 1px, transparent 1px), linear-gradient(90deg, rgba(52, 211, 153, 0.25) 1px, transparent 1px)",
    backgroundSize: "64px 64px",
    maskImage: "radial-gradient(circle 200px at -1000px -1000px, black 0%, transparent 100%)",
    WebkitMaskImage: "radial-gradient(circle 200px at -1000px -1000px, black 0%, transparent 100%)",
  };

  const fadeMask = {
    maskImage: "radial-gradient(ellipse 60% 50% at 50% 0%, black 30%, transparent 100%)",
    WebkitMaskImage: "radial-gradient(ellipse 60% 50% at 50% 0%, black 30%, transparent 100%)",
  };

  return (
    <div
      ref={containerRef}
      className="absolute inset-0 pointer-events-none"
      style={fadeMask}
    >
      {/* Base grid — always visible */}
      <div className="absolute inset-0" style={gridStyle} />
      {/* Bright grid — follows mouse */}
      <div ref={glowRef} className="absolute inset-0" style={glowGridStyle} />
    </div>
  );
}
